import React from 'react'
import './css/Footer.css'
import Logo from './../assets/icons/Logo.png'
import { AiFillYoutube, AiFillInstagram, AiFillFacebook } from 'react-icons/ai'

function Footer() {
    return (
        <div className='Footer'>
            <div className='one'>
                <img src={Logo} alt='Logo' />
                <p>An esteemed catering brand offering exquisite,
                    handcrafted culinary experiences inspired by
                    global flavours.
                </p>
            </div>
            <div className='two'>
                <h3>ADDRESS</h3>
                <p> Plaza Catering Service <br />
                    Palakkad - Ponnani Rd<br />
                    Vaniyamkulam-I<br />
                    Palakkad Dist. <br />
                    Kerala - 679 523
                </p>
            </div>
            <div className='three'>
                <h3>CONTACT</h3>
                <p>+91 9539 100 000</p>
                <p>+91 9846 30 1234</p>
                <p><a href='mailto:info@plazacatering.co.in' className='text-white'>info@plazacatering.co.in</a></p>
                <div className='socials'>
                    <a href='https://www.youtube.com/@plazacateringservice9512' rel="noreferrer" target='_blank'><AiFillYoutube /></a>
                    <a href='https://www.instagram.com/plazacateringservice' rel="noreferrer" target='_blank'><AiFillInstagram /></a>
                    <a href='https://www.facebook.com/plaza.26/' rel="noreferrer" target='_blank'><AiFillFacebook /></a>
                </div>
            </div>
        </div>
    )
}

export default Footer